import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadComprobantesCobranzas } from '../../../store/slices/configuracionesSlice';
import ComprobantesConfigBody from './ComprobantesConfigBody';

const ComprobantesCobranzas = (props) => {
  const dispatch = useDispatch();
  const comprobantes = useSelector(state => state.configuraciones.comprobantesCobranzas.items);
  const loading = useSelector(state => state.configuraciones.comprobantesCobranzas.loading);
  const onLoad = (empresaId) => dispatch(loadComprobantesCobranzas(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <ComprobantesConfigBody
      comprobantes={comprobantes}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default ComprobantesCobranzas;